<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="halloween">
<h1>Halloween</h1>
<p style="text-indent:0px;">Ghouls frighten the unprepared,</p>
<p style="text-indent:0px;">Ghostly figures are now seen.</p>
<p style="text-indent:0px;">A time of hearts beating scared,</p>
<p style="text-indent:0px;">It can only be that it is Halloween.</p><br/>
<p style="text-indent:0px;">A passage to another world,</p>
<p style="text-indent:0px;">Tears through another world’s veil thin.</p>
<p style="text-indent:0px;">Children frightened under blankets curled,</p>
<p style="text-indent:0px;">With goose bumps forming upon their skin.</p><br/>
<p style="text-indent:0px;">Imagination running riot,</p>
<p style="text-indent:0px;">All manner of demon is conjured.</p>
<p style="text-indent:0px;">An empty cemetery that was once silent,</p>
<p style="text-indent:0px;">Alive now with visions no longer blurred.</p><br/>
<p style="text-indent:0px;">An ancient game of trick or treat,</p>
<p style="text-indent:0px;">Is played wrong by way of lost translations.</p>
<p style="text-indent:0px;">You better hope that you get a sweet,</p>
<p style="text-indent:0px;">Or you may end up in a mangled conditions.</p><br/>
<p style="text-indent:0px;">The night of the dead amongst the breathing,</p>
<p style="text-indent:0px;">Dressing up to copy the unknown.</p>
<p style="text-indent:0px;">You never know what horrors you are inviting,</p>
<p style="text-indent:0px;">You may end up on Satan’s throne.</p><br/>
<p style="text-indent:0px;">It is seen as fun and games for an adult,</p>
<p style="text-indent:0px;">Dressing up to look the best.</p>
<p style="text-indent:0px;">For one night you are the leader of a cult,</p>
<p style="text-indent:0px;">Awake from your pretend eternal rest.</p><br/>
<p style="text-indent:0px;">Make sure in the morning you are the same,</p>
<p style="text-indent:0px;">You are not in a wooden asylum.</p>
<p style="text-indent:0px;">Make sure you weren’t driven possessed insane,</p>
<p style="text-indent:0px;">To spend your life staring at a padded horizon.</p>
<p style="text-indent:0px;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?2bfef80f